import AddSupporter from './AddSupporter';

export default AddSupporter;
